module.exports = __webpack_public_path__ + "media/theme/sample__nintendo--sp-b680efdd.png";